/**
 * @ticket TM-1000001960
 * Entity-service registry for the au (Auth Administration) module.
 * Route-only registration — the generic CRUD framework resolves services/components by convention.
 */
import {ENTITY_SERVICE_REGISTRY, EntityServiceEntry} from "../../core/shared/dto/dto-service/entity-service-registry";

export const AU_ENTITY_PROVIDER = [
    {
        provide: ENTITY_SERVICE_REGISTRY,
        useValue: [
            ['au.AuApplication', {route: '/au/auApplications'}],
            ['au.AuApplicationRedirectUri', {route: '/au/auApplicationRedirectUris'}],
            ['au.AuIdentityProvider', {route: '/au/auIdentityProviders'}],
            ['au.AuLoginPolicy', {route: '/au/auLoginPolicies'}],
            ['au.AuTenantRegistry', {route: '/au/auTenantRegistries'}],
            ['au.AuSigningKey', {route: '/au/auSigningKeys'}],
            ['au.AuAuthEvent', {route: '/au/auAuthEvents'}],
            ['au.AuAuthStatDaily', {route: '/au/auAuthStatDailies'}],
        ] as EntityServiceEntry[],
        multi: true
    }
];
